/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountHierarchyTree} from '../models/AccountHierarchyTree';
import type {Error} from '../models/Error';

export interface GetAccountHierarchyTree$Request {
    accountId: number;
}

export interface GetAccountHierarchyTree$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountHierarchyTreeRequest = createAction<PayloadData<void, GetAccountHierarchyTree$Request>>('ACCOUNT_HIERARCHY__GET_ACCOUNT_HIERARCHY_TREE__REQUEST');
export const getAccountHierarchyTreeSuccess = createAction<PayloadData<AccountHierarchyTree, GetAccountHierarchyTree$Request>>('ACCOUNT_HIERARCHY__GET_ACCOUNT_HIERARCHY_TREE__SUCCESS');
export const getAccountHierarchyTreeFailure = createAction<PayloadData<Error, GetAccountHierarchyTree$Request, true>>('ACCOUNT_HIERARCHY__GET_ACCOUNT_HIERARCHY_TREE__FAILURE');

export const getAccountHierarchyTreeActions = [
    getAccountHierarchyTreeRequest,
    getAccountHierarchyTreeSuccess,
    getAccountHierarchyTreeFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountHierarchyTree = (meta: GetAccountHierarchyTree$Request, config?: GetAccountHierarchyTree$Config) => {
    return {
        CALL_API: {
            types: getAccountHierarchyTreeActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/hierarchy`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

